import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { result } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { RestApiService } from 'src/app/Service/rest-api.service';

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.css']
})
export class AttachmentsListComponent implements OnInit {
  public messageId!: number;
  public documentList: any[] = [];
  public messageList: any[] = [];

  constructor(
    public restApiService: RestApiService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public commonService: CommonService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<AttachmentsListComponent>,
    private communicationService: CommunicationService,
  ) { }
  ngOnInit() {
    this.messageId = this.data["messageId"];
    this.getMessageList();
    this.getDocumentList();
  }
  public togglePopupDialog() {
    this.dialogRef.close();
  }
  /**
   * Data Binding in Grid
   * @param type
   *
   */
  public getMessageList() {
    this.communicationService.getMessageAttachmentsList(this.messageId).subscribe((data: any[]) => {
      this.data = data.map(x => {
        let result: any = {
          messageId: x.messageId,
          attachedMessageId: x.attachedMessageId,
          fromMemberName:x.fromMemberName,
          toMemberName:x.toMemberName,
          messageNumber:x.messageNumber,
          messageSubject:x.messageSubject
        };
        return result;
      });
      this.messageList = this.data;
      return result;
    });
  }

  /**
   * Data Binding in Grid
   * @param type
   *
   */
  public getDocumentList() {

    this.communicationService.getMessageDocumentsList(this.messageId).subscribe((data: any[]) => {
      this.data = data.map(x => {
        let result: any = {
          messageId: x.messageId,
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          revisedOn: x.revisedOn,
          createdBy: x.createdBy,
          authorisedBy: x.authorisedBy
        };
        return result;
      });
      this.documentList = this.data;
      return result;
    }); 
  }
  
}
